import * as Mui from "@mui/material";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { Link, useLocation, useParams } from "react-router-dom";
import { useMemo } from "react";

interface Props {
  transferRequest?: string;
}

const TransferRequestTabs = (props: Props) => {
  const t = useOperationTranslation();
  const location = useLocation();
  const { id } = useParams();

  const basePath = useMemo(
    () => `/operation/transfer/transferRequests/details/${id}`,
    []
  );

  return (
    <Mui.Box component={"div"} pl={2} pr={2}>
      <Mui.Tabs
        sx={{ boxShadow: "0px -4px 0px rgba(151, 151, 151, 0.2) inset" }}
        TabIndicatorProps={{
          sx: {
            height: "5px",
            backgroundColor: "rgba(200, 1, 125, 1)",
          },
        }}
        value={location.pathname}
        aria-label="basic tabs example"
      >
        <Mui.Tab
          to={basePath}
          component={Link}
          label={
            <Mui.Box>
              <Mui.Typography>
                {t("transferReason.details.navigate.transferRequest")}
              </Mui.Typography>
            </Mui.Box>
          }
          value={basePath}
        ></Mui.Tab>
        <Mui.Tab
          to={`${basePath}/carsegment`}
          component={Link}
          label={
            <div>
              <Mui.Typography>
                {t("transferReason.details.navigate.carSegment")}
              </Mui.Typography>
            </div>
          }
          value={`${basePath}/carsegment`}
        ></Mui.Tab>
        <Mui.Tab
          to={`${basePath}/vehicles`}
          component={Link}
          label={
            <div>
              <Mui.Typography>
                {t("transferReason.details.navigate.vehicles")}
              </Mui.Typography>
            </div>
          }
          value={`${basePath}/vehicles`}
        ></Mui.Tab>
        {props?.transferRequest !== "Driver" && (
          <Mui.Tab
            to={`${basePath}/tenders`}
            component={Link}
            label={
              <div>
                <Mui.Typography>
                  {t("transferReason.details.navigate.tender")}
                </Mui.Typography>
              </div>
            }
            value={`${basePath}/tenders`}
          ></Mui.Tab>
        )}
        <Mui.Tab
          to={`${basePath}/drivers`}
          component={Link}
          label={
            <div>
              <Mui.Typography>
                {t("transferReason.details.navigate.drivers")}
              </Mui.Typography>
            </div>
          }
          value={`${basePath}/drivers`}
        ></Mui.Tab>
      </Mui.Tabs>
    </Mui.Box>
  );
};

export default TransferRequestTabs;
